
import Programs from "@/components/Programs";
import Header from "@/components/Header";
import Footer from "@/components/Footer";
import BackToTop from "@/components/BackToTop";

const ProgramsPage = () => {
  return (
    <div className="min-h-screen bg-white overflow-x-hidden">
      <Header />
      <div className="pt-8">
        <Programs />
      </div>
      <Footer />
      <BackToTop />
    </div>
  );
};

export default ProgramsPage;
